import { render, staticRenderFns } from "./lie-registro.vue?vue&type=template&id=a28d44fe&"
import script from "./lie-registro.component.ts?vue&type=script&lang=ts&"
export * from "./lie-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports